export default "__VITE_ASSET__BX36$9sc__"